import { FC } from "react";
import { ISimpleGrid } from "@cayo/admin-components/components/grids/SimpleGrid/types";

interface ISimpleGridItem {
  displayName: string;
}

interface SimpleGridProps extends ISimpleGrid {
  items: ISimpleGridItem | ISimpleGridItem[];
}

const SimpleGrid: FC<SimpleGridProps> = () => null;

export default SimpleGrid;
